import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CertificacionPrecio } from '../models/PlanesUsuario/CertificacionPrecio';
import { HttpParams } from '@angular/common/http';
import {
  DatosFacturacion,
  EmpresaFacturacion,
} from '../models/PlanesUsuario/DatosFacturacion';
import { Plan } from '../models/PlanesUsuario/Plan';
import { PlanUsuario } from '../models/PlanesUsuario/PlanUsuario';
import { Resumen } from '../models/PlanesUsuario/Resumen';
import { Reseller } from '../models/Reseller/Reseller';
import { ResellerFilter } from '../models/Reseller/ResellerFilter';
import { Page } from '../shared/models/Page';
import { PagedResponse } from '../shared/models/PagedResponse';
import { Response } from '../shared/models/Response';
import { SoporteButton } from '../shared/models/SoporteButton.enum';

@Injectable({
  providedIn: 'root',
})
export class DatosFacturacionService {
  private REST_API_SERVER = environment.backend_server + '/datosfacturacion';

  constructor(private http: HttpClient) {}

  getData(usuarioId: string, emisorId: string) {
    return this.http.get<Array<EmpresaFacturacion>>(this.REST_API_SERVER + '/' + usuarioId + '/' + emisorId);
  }
 ObtenerDatosFacturacion(emisorId?: string | null, rutFacturacion?: string | null) {
  let params = new HttpParams();

  if (emisorId?.trim()) {
    params = params.set('idEmisor', emisorId.trim());
  }

  if (rutFacturacion?.trim()) {
    params = params.set('rutFacturacion', rutFacturacion.trim());
  }

  return this.http.get<Array<EmpresaFacturacion>>(
    `${this.REST_API_SERVER}`,
    { params }
  );
}
}
